/* eslint-disable @stencil-community/required-jsdoc */
import { Host, h } from "@stencil/core";
export class ChSelectItem {
    constructor() {
        this.height = undefined;
        this.leftIconSrc = undefined;
        this.rightIconSrc = undefined;
        this.selected = undefined;
        this.disabled = undefined;
        this.autoColor = true;
        this.value = undefined;
    }
    /**
     * Emits the item id
     */
    itemClicked;
    el;
    selectOption;
    componentDidRender() {
        if (this.el.hasAttribute("disabled")) {
            this.selectOption.setAttribute("disabled", "");
        }
        if (this.el.hasAttribute("selected")) {
            this.selectOption.classList.add("option-selected");
            const selectedOptionText = this.el.parentElement.shadowRoot.querySelector("span.text");
            selectedOptionText.innerHTML = this.el.innerHTML;
        }
    }
    optionClickedHandler(event) {
        const targetOption = event.el.value;
        if (!event.disabled) {
            this.setActiveOption(targetOption);
            this.itemClicked.emit({ "option-value": targetOption });
        }
    }
    setActiveOption(targetItem) {
        const parent = this.el.parentElement;
        const selectItems = parent.children;
        let optionText = "";
        for (let i = 0; i < selectItems.length; i++) {
            const item = selectItems[i].shadowRoot.lastChild;
            // remove old item selected class
            if (item.classList.contains("option-selected")) {
                item.classList.remove("option-selected");
            }
            selectItems[i].removeAttribute("aria-selected");
            // remove pre-selection attribute
            selectItems[i].removeAttribute("selected");
            // set active item class
            if (selectItems[i].value === targetItem.trim()) {
                item.classList.add("option-selected");
                selectItems[i].setAttribute("aria-selected", "true");
                optionText = selectItems[i].innerHTML;
            }
        }
        // update selected option text in select
        const selectedOptionText = this.el.parentElement.shadowRoot.querySelector("span.text");
        selectedOptionText.innerHTML = optionText;
    }
    resolveLeftIcon() {
        if (this.leftIconSrc !== undefined) {
            return this.leftIconSrc;
        }
        return "";
    }
    resolveRightIcon() {
        if (this.rightIconSrc !== undefined) {
            return this.rightIconSrc;
        }
        return "";
    }
    render() {
        return (h(Host, { key: 'db16855668d327e2e12604eaa7d9bb787e230b19', class: "option", role: "option", value: this.value, onClick: () => this.optionClickedHandler(this) }, h("div", { key: '324f41eda4a0724e388daec2caf68ef33a9d8649', class: "option", exportparts: "option-text: select-option", ref: el => (this.selectOption = el), style: { height: this.height } }, h("div", { key: '9bfd516bc253c26aa4518c1757979d54c29134f5', class: "left-container" }, this.leftIconSrc && (h("span", { key: '87a424469ad208c1bc53470eededdc5638a731e3', class: "icon left-icon" }, h("ch-icon", { key: 'be61f397de797a42917f32feb7bb729235c7d50a', src: this.resolveLeftIcon(), style: {
                "--icon-size": "20px",
                "--icon-color": `var(--first-list-icon-color)`
            }, "auto-color": this.autoColor }))), h("span", { key: 'e08515af2bf3bf908a678745437f62cb308e02db', class: "text", part: "option-text" }, h("slot", { key: '9ca303914431e3130b74d36b1ae6303a94259846' }))), this.rightIconSrc && (h("span", { key: '7a09c19a6cf0ef0f963708eb6db063901e308109', class: "icon right-icon" }, h("ch-icon", { key: '8d4f2e95039af1b155665189a92630ae8b4df013', src: this.resolveRightIcon(), style: {
                "--icon-size": "20px",
                "--icon-color": `var(--first-list-icon-color)`
            }, "auto-color": this.autoColor }))))));
    }
    static get is() { return "ch-select-option"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-select-option.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-select-option.css"]
        };
    }
    static get properties() {
        return {
            "height": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "height",
                "reflect": false
            },
            "leftIconSrc": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Set the left side icon"
                },
                "attribute": "left-icon-src",
                "reflect": false
            },
            "rightIconSrc": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Set the right side icon"
                },
                "attribute": "right-icon-src",
                "reflect": false
            },
            "selected": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Determines the selected option"
                },
                "attribute": "selected",
                "reflect": true
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Determines if the option is disabled"
                },
                "attribute": "disabled",
                "reflect": true
            },
            "autoColor": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "true",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If enabled, the option icons will display its inherent/natural color"
                },
                "attribute": "auto-color",
                "reflect": true,
                "defaultValue": "true"
            },
            "value": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The select option's value"
                },
                "attribute": "value",
                "reflect": true
            }
        };
    }
    static get events() {
        return [{
                "method": "itemClicked",
                "name": "itemClicked",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emits the item id"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "el"; }
}
